import {FC, PropsWithChildren} from "react";
import { Form } from "react-bootstrap";

interface Props extends PropsWithChildren {
}
const RRFormLabel: FC<Props> = (props) => {
    return (
        <Form.Label className="mt-2">{props.children}</Form.Label>
    )
}

export default RRFormLabel;
